export default [
  {
    path: '/ticket',
    name: 'ticket',
    component: () => import('@/views/ticket/ticket.vue'),
    meta: {
      resource: 'chat',
      title: 'breadcrumb.chat',
    },
  },
]
